<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="账号" prop="userName">
              <a-input v-model="formInline.userName" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="手机号码" prop="phone">
              <a-input
                v-model="formInline.phone"
                type="user"
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="角色名称" prop="uids">
              <a-select
                v-model="formInline.roleId"
                default-value=""
                style="width: 120px"
                @change="handleChange"
              >
                <a-select-option
                  v-for="(item, index) in xiala"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.roleName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <permissionsContent
          :formInline="formInline"
          ref="iason"
        ></permissionsContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import permissionsContent from "./permissionsContent.vue";
import { permissionsListXiala } from "@/api/homeApi.js";
export default {
  components: {
    permissionsContent,
  },
  data() {
    return {
      formInline: {
        userName: "",
        phone: "",
        roleId: "",
        limit: 10,
        page: 1,
      },
      xiala: [],
    };
  },
  created() {
    this.getpermissionsListXiala();
  },
  methods: {
    getpermissionsListXiala() {
      permissionsListXiala().then((res) => {
        this.xiala = res.data;
      });
    },
    storeType(e) {
      this.formInline.store = e;
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.iason.query();
    },
    resetForm() {
      this.$refs.iason.getData();
      this.formInline.userName = "";
      this.formInline.phone = "";
      this.formInline.roleId = "";
    },
    handleChange(value) {
      console.log(value);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/right/permissions/permissionsHome.vue